import React, { PropsWithChildren } from 'react';
import { useMutation } from '@apollo/client/react/hooks';
import { gql } from '@yi/core';
import { i18n_create } from '@yi/i18n/phrases/i18n_create';
import { i18n_create_playlist } from '@yi/i18n/phrases/i18n_create_playlist';

import { notifyBugsnag } from '~/common';
import { TSFixMe } from '~/types';

import { PlaylistModal, PlaylistModalProps } from './PlaylistModal';
import { useLocale } from '../LocaleProvider';

export const CreatePlaylistModal: React.FC<
  PropsWithChildren<
    Pick<PlaylistModalProps, 'open' | 'setClose' | 'contentTitle'> & {
      onSubmitAction?: (params: {
        playlistName: string;
        playlistDescription?: string;
      }) => Promise<TSFixMe>;
    }
  >
> = ({ onSubmitAction, contentTitle, ...props }) => {
  const { locale } = useLocale();
  const [createPlaylist] = useMutation<
    gql.typesClient.Mutate_CreatePlaylist,
    gql.typesClient.Mutate_CreatePlaylistVariables
  >(gql.Mutate_CreatePlaylist, {
    onError: error => {
      notifyBugsnag(error);
      console.warn('error: ', error);
    },
  });

  return (
    <PlaylistModal
      contentTitle={contentTitle}
      title={i18n_create_playlist(locale)}
      buttonText={i18n_create(locale)}
      onSubmit={values =>
        onSubmitAction
          ? onSubmitAction(values)
          : createPlaylist({
              variables: { title: values.playlistName, description: values.playlistDescription },
              update: (cache, { data }) => {
                if (
                  !data ||
                  !data.createPlaylist ||
                  !data.createPlaylist.playlist ||
                  !data.createPlaylist.playlist.length
                ) {
                  return console.warn('add to new playlist request failed');
                }

                cache.writeQuery<gql.typesClient.Query_AllPlaylists>({
                  query: gql.Query_AllPlaylists,
                  data: {
                    allPlaylists: data.createPlaylist.playlist,
                  },
                });
              },
            })
      }
      {...props}
    />
  );
};
